import SiafLiteApiRepository from "../../external/siafLiteApi";

class OrdemServicosStatusPersonalizadosService {
  constructor() {
    this.urlBase = "/faturamento/ordem-servicos-status-personalizados";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  getAll(filter = {}) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get({
      ...filter,
      nonPaginated: true,
    });
  }
}

export default OrdemServicosStatusPersonalizadosService;
